import React from 'react';
import { Box } from 'rebass';

const Spinner = () => (
  <Box py={5} />
);

export default Spinner;
